import Yup from '_zari/validation/_yup'

import { TiposDocumentoSunatConstant } from 'constants/index'

export const ValidationSchema = Yup.object().shape({
  tipoDocumento: Yup.string().required(),
  fechaEmision: Yup.string().required(),
  numeroDocumento: Yup.string().when('tipoDocumento', {
    is: TiposDocumentoSunatConstant.OTROS,
    then: Yup.string().required()
  }),
  serieDocumento: Yup.string().when('tipoDocumento', {
    is: TiposDocumentoSunatConstant.OTROS,
    then: Yup.string().required()
  })
})
